import { Component, OnInit } from '@angular/core';
import { Workstep } from '../../../../_models/workstep';
import * as fromWorkstep from '../../state/workstep.reducer';
import * as workstepActions from '../../state/workstep.actions';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './workstep-edit-shell.component.html'
})

export class WorkstepEditShellComponent implements OnInit {
  currentWorkstep$: Observable<Workstep>;
  filterFields$:  Observable<any>;

  constructor(
    private store: Store<fromWorkstep.State>,
  ) { }

  ngOnInit() {
    this.currentWorkstep$ = this.store.pipe(select(fromWorkstep.getCurrentWorkstep)) as Observable<Workstep>;
    this.filterFields$ = this.store.pipe(select(fromWorkstep.getFilterFields)) as Observable<any>;
  }

  createWorkstep(params: any) {
    console.log('---> Running createWorkstep....');
    this.store.dispatch(new workstepActions.CreateWorkstep(params));
  }

  updateWorkstep(params: any) {
    console.log('---> Running updateWorkstep....');
    this.store.dispatch(new workstepActions.UpdateWorkstep(params));
  }
}
